export {};

declare global {
  interface Number {
    toNumber(): string;
    toKM(): string;
    toKG(): string;
  }
}
Number.prototype.toNumber = function (): string {
  try {
    const toCurrency = this.toLocaleString("en-US", {});
    return `${toCurrency || 0}`;
  } catch (error) {
    return "";
  }
};

Number.prototype.toKM = function (): string {
  try {
    const toNumb = this.toNumber();
    return `${toNumb || 0} KMs`;
  } catch (error) {
    return "";
  }
};

Number.prototype.toKG = function (): string {
  try {
    const toNumb = this.toNumber();
    return `${toNumb || 0} KGs`;
  } catch (error) {
    return "";
  }
};
